import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow, ItemIcon } from "@similarweb/ui-components";

export const Container = styled(FlexColumn)`
    flex-grow: 1;
    height: 100%;
`;

export const ItemsGroup = styled(FlexColumn)`
    flex: 1;
    overflow-y: auto;
    gap: 24px;
`;

export const TotalGroup = styled(FlexColumn)`
    margin-top: 24px;
    gap: 24px;
`;

export const Separator = styled.div`
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledItemIcon = styled(ItemIcon)`
    width: 20px;
    height: 20px;

    img {
        width: 12px;
        height: 12px;
    }
`;

export const BarWrapper = styled(FlexColumn)`
    gap: 8px;
`;

export const LabelRow = styled(FlexRow)`
    line-height: 16px;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    color: ${colorsPalettes.carbon[500]};
`;

export const Dot = styled.span`
    color: ${colorsPalettes.carbon[200]};
`;
